import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { AdditionalInterestComponent } from "premier-capability-policyjob-react";
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './LiabilityCoveragesPage.metadata.json5';
import messages from './LiabilityCoveragesPage.messages.js';
import styles from '../Miscellaneous/MiscellaneousPage.module.scss'

import CoveragesPageComponent from "../Coverages/CoveragesPage";

function LiabilityCoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    
    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation
    } = useValidation('ArchitectEngineersPage');


    useEffect(() => {

    }, []);

    const overrideProps = {
        pplLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.proLine.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages',
            pathToGet: 'proLine.coverages'
        },
        additionalInterest:{
            value: submissionVM,
            path: `lobData.proLine.coverables.additionalInterests`,
            type: 'additionalInterest',
            onValueChange: updateWizardData,
            authHeader
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            additionalInterestComponent: AdditionalInterestComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => _.find(submissionVM.value.lobData.proLine.lineCoverages.coverages, { isValid: false })

    return (
        <WizardPage skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LiabilityCoveragesPage.propTypes = wizardProps;
export default withRouter(LiabilityCoveragesPage);
